import React from "react";
import { useLoaderData } from "react-router-dom";
import Aside from "./Aside";

import Topic from "./Topic";

const Courses = () => {
  const data = useLoaderData();

  // const{data} = Subject
  console.log(data);
  return (
    <div>
      <h1 className="mt-3 ms-5 text-course fw-bold text-warning">Courses</h1><br></br>
      <h5 className="ms-5 w-50 text-secondary">Our course list is arranged with those skills which are currently in most 
        demand in the country and outside the country. From here you can enroll in 
        the course online or offline anytime at your convenience.</h5>
      <div className="home">
        
        {/* <h2 className="bg-warning">this is something</h2> */}
        <div className="topic mt-5">
          {data.map((sub) => (
            <Topic key={sub.id} sub={sub}></Topic>
          ))}
        </div>
        <div className="aside ms-3 mt-5 ">
          <Aside></Aside>
        </div>
      </div>
    </div>
  );
};

export default Courses;
